import { call } from 'redux-saga/effects';
import axios from 'axios';

function uploadFileCall(file, source) {
    let f = new FormData();
    f.append("File", file, file.name)
    f.append("source", source)

    return axios({
        method: 'post',
        url: '/api/Application/uploadfile',
        data: f,
        headers: { 'Content-Type': 'multipart/form-data' }
    })
};

export function* uploadFiles(file, source) {
    try {
        const response = yield call(uploadFileCall, file, source);
        const supFile = {
            storageKeyFileName: response.data.data.storageKey,
            storageDisplayName: response.data.data.displayName 
        };
        return supFile;
    } catch (error) {
    }
    return null;
}
